<template>
    <div class="">
        <slot :customData="customData" :setCustomData="setCustomData"></slot>
    </div>
</template>

<script>
    export default
    {
        props: {
            defaultCustomData: null
        },
        data() {
            return {
                customData: this.defaultCustomData
            };
        },
        whatch: {
            defaultCustomData: {
                handler( defaultCustomData) {
                    this.customData = defaultCustomData;
                },
                deep: true
            }
        },
        methods: {
            setCustomData( customData ) {
                this.customData = customData;
            }
        }
    }
</script>
